<template>
    <div class="wrapper mt-3">
        <h4>Vertretersortimente</h4>
        <div class="row">
            <div class="col">
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="s in userlist" :key="s.map_id">
                        <span>{{ s.sort_id }}</span>
                        <button @click="remSelection(s)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
                    </li>  
                </ul>
            </div>
            <div class="col">
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="s in sortlist" :key="s.map_id">
                        <span>{{ s.name }}</span>
                        <button @click="addSelection(s.map_id)" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import articles   from '@/modules/articles.js'
import ihandusers from '@/modules/ihanduser.js'

export default {
    name: 'iHandUserSelections',
    props: ["handid"],
    data() {
        return {
            userlist: [],
            sortlist: []
        }
    },
    watch: {
        handid: function(val) {
            console.log('updated handid',this.handid,val);
            if (val && val !== '') {
                this.fetchData();
            }
        }
    },
    mounted() {
      this.fetchSorts();  
    },
    methods: {
        // soritment vom aktuellen vertreter entfernen
        remSelection(entry) {
          console.log('rem entry',entry);  
        },
        // sortiment dem aktuellen vertreter hinzufügen
        addSelection(map_id) {
            var self  = this;
            var entry = { "hand_id": this.handid,"sort_id":map_id};
            console.log('save entry:',entry);
            ihandusers.saveselection(entry).then(function(data) {
                console.log('selection saved');
                self.fetchData();
            }).catch(function(err) {
                console.error('Fehler bei Vertretersortimente laden: ' + err);                
            });
        },
        // laden der allgemeinen sortimentsliste 
        fetchSorts() {
            var self = this;
            articles.searchSelections(this,0,1000,'',function(data) {
                console.log('sortiment liste',data);
                self.sortlist = data;
            });
        },
        // laden der vertreter sortimente
        fetchData() {
            var self = this;
            ihandusers.listselections(this.handid,0,500).then(function(data) {
                self.userlist = data;
            }).catch(function(err) {
                console.error('Fehler bei Vertretersortimente laden: ' + err);
            })
        }
    }
}
</script>